import React from 'react'
import { DataTool } from '@ztechapps/webui.data-tools'
import { useTaskListContext } from './Context'
import map from 'lodash/map'
import { taskFieldsConfig } from '@ztechapps/task.common'
import { NullComponent, ShowIf } from '@ztechapps/webui.util'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'

export const DataAction = () => {
  const { localListAction, components } = useTaskListContext()

  const otherButtons = (props) => {
    return (
      <ButtonGroup className="d-flex flex-wrap align-items-center gap-2">
        <DeleteManyTaskButton />
        <components.dataAction.other {...props} />
      </ButtonGroup>
    )
  }

  return (
    <div className="d-flex justify-content-end">
      <DataTool
        {...localListAction}
        fieldsConfig={taskFieldsConfig}
        filterCategory="filter_project_task"
        components={{ other: otherButtons, sort: NullComponent, refresh: NullComponent }}
        searchPlaceHolder="Search task list."
      />
    </div>
  )
}

export const DeleteManyTaskButton = () => {
  const {
    taskListWithSelection: { hasSelected, selectedList },
    onDelete,
  } = useTaskListContext()

  const onClick = async () => {
    const taskIds = map(selectedList, (e) => e._id)
    await onDelete(taskIds)
  }

  return (
    <ShowIf condition={hasSelected}>
      <BusyButton variant="danger" title="Delete all selected tasks" icon="trash" onClick={onClick} />
    </ShowIf>
  )
}
